<template>
  <div>
    <div class="msg-push-info">
      <div class="title">本次推送基本信息</div>
      <div class="flex">
        <div class="img mr10">
          <el-image style="width: 100%" :src="msgInfo.img" fit="fit"></el-image>
        </div>
        <div class="flex-1 flex flex-column flex-center">
          <div class="flex msg-info">
            <div class="flex-1" style="font-size: 16px; font-weight: 600">
              计划名称：{{ recordModel.planName }}
            </div>
            <div class="flex-1 flex">
              计划状态：
              <div v-if="recordModel.planStatus === 'notStart'" class="gray">
                未开始
              </div>
              <div
                v-else-if="recordModel.planStatus === 'running'"
                class="success"
              >
                进行中
              </div>
              <div v-else-if="recordModel.planStatus === 'end'" class="gray">
                已结束
              </div>
              <div
                v-else-if="recordModel.planStatus === 'errorStop'"
                class="danger"
              >
                异常暂停
              </div>
              <div v-else-if="recordModel.planStatus === 'stop'" class="orange">
                暂停
              </div>
            </div>
            <div class="flex-1">计划方式：长期计划</div>
            <div class="flex-1">
              计划时间：{{ recordModel.planStartDate }}至{{
                recordModel.planEndDate
              }}
            </div>
          </div>
          <div class="flex mt10 msg-info">
            <div class="flex-1">
              权益礼包：{{
                recordModel.couponSendName ? recordModel.couponSendName : "无"
              }}
            </div>
            <div class="flex-1">推送时间：{{ recordModel.triggerTime }}</div>
            <div class="flex-1"></div>
            <div class="flex-1"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="msg-push-info" style="padding-bottom: 50px">
      <div class="title">本次推送运营数据</div>
      <!-- <div class="flex flex-end">
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
      </div> -->

      <div class="flex flex-center mt20">
        <div
          class="flex-1 flex purchase-data p10"
          :class="{ mr20: i < list.length - 1 }"
          v-for="(v, i) in list"
          :key="i"
        >
          <div class="hm-icon mr10">
            <span class="hmicon" :class="v.icon"></span>
          </div>
          <div class="flex-1">
            <el-tooltip
              class="tooltip"
              effect="light"
              :content="v.tip"
              placement="top"
            >
              <div class="purchase-name mt10 flex item-center">
                {{ v.name }}

                <i
                  class="el-icon-question"
                  style="font-size: 18px; color: #ddd"
                ></i>
              </div>
            </el-tooltip>
            <div class="mt10 flex flex-between item-center">
              <div class="purchase-val" v-if="i === 4">
                ￥{{ toPriceNum(v.val.toFixed(2)) }}
              </div>
              <div class="purchase-val" v-else>
                {{ v.val }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="funnel mt20 flex flex-column flex-center">
        <div
          class="funnel-row flex-1 flex flex-column flex-center ml20"
          v-for="(v, i) in h"
          :key="i"
        >
          <div class="flex">{{ v.name }}</div>
          <div>{{ v.val }}</div>
          <div class="tit">{{ v.name }}</div>
        </div>
        <div class="cover-notice">
          转化率
          <div>{{ coverNumRatio }}</div>
        </div>
        <div class="cover-access">
          转化率
          <div>{{ noticeNumVisRatio }}</div>
        </div>
        <div class="notice-purchase">
          转化率
          <div>{{ noticeNumRatio }}</div>
        </div>
        <div class="cover-purchase">
          转化率
          <div>{{ payNumRatio }}</div>
        </div>
      </div>
    </div>
    <div class="msg-push-info">
      <div class="title">本次推送商品效果</div>
      <div>
        <el-table
          stripe
          ref="btable"
          :data="listResult"
          style="width: 100%"
          id="table"
          size="small"
          max-height="300"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="推送商品"
            width="300"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="推送时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="noticeNum"
            label="通知次数"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="ratio"
            label="复购率"
          >
            <!-- <template slot-scope="scope">
              <div class="flex item-center flex-center">
                {{}} <span class="success mr10">表现良好</span>
                <span class="hmicon icon-piliangqueren success"></span>
              </div>
            </template> -->
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      listResult: [],
      h: [
        {
          name: "覆盖次数",
          val: 0
        },
        {
          name: "通知次数",
          val: 0
        },
        {
          name: "访问次数",
          val: 0
        },
        {
          name: "复购次数",
          val: 0
        }
      ],
      list: [
        {
          icon: "icon-fugairenshu",
          name: "覆盖次数(次）",
          val: 0,
          tip: "统计时间内覆盖到用户的次数，一个覆盖用户多次计算为多个次数 ",
          pathName: ""
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "通知次数(次）",
          val: 0,
          tip: "统计时间内给用户发送通知的次数，一个用户多次发送通知的计算为多个次数",
          pathName: ""
        },
        {
          icon: "icon-fangwenrenshu",
          name: "访问次数(次）",
          val: 0,
          tip: "统计时间内给用户发送通知后用户访问的次数，一个用户多次发送通知后访问计算为多个次数",
          pathName: ""
        },
        {
          icon: "icon-fangwenrenshu",
          name: "付款次数(次）",
          val: 0,
          tip: "统计时间内用户复购付款的次数，此处由于暂计算了自然购买+通过通知的客户数",
          pathName: "PotentialGoods"
        },
        {
          icon: "icon-fukuanjine",
          name: "复购付款金额(元）",
          val: 0,
          tip: "复购付款金额",
          pathName: ""
        }
      ],
      createTimeArry: [],
      msgInfo: {
        img: "https://imgcdn.hemiao100.com/ThemePictures/defaultgood.png",
        goodsName: "惠氏三段新西兰进口羊奶粉 800g",
        time: "2020-12-04 12:00:00"
      },
      row: JSON.parse(this.$route.query.row),
      searchCondition: {},
      recordModel: {},
      coverNumRatio: "0%",
      noticeNumVisRatio: "0%",
      noticeNumRatio: "0%",
      payNumRatio: "0%"
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryInfo();
  },
  methods: {
    async queryInfo() {
      const params = {
        id: this.row.id
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "getRepurchasePlanExecRecordCensus",
        params
      );
      if (code === "0") {
        const {
          recordModel,
          repurchaseSkuList,
          coverNum,
          noticeNum,
          payNum,
          payPrice,
          visitNum
        } = result;
        this.recordModel = recordModel;
        repurchaseSkuList.forEach(v => {
          if (v.payNum && v.noticeNum) {
            v.ratio = ((v.payNum / v.noticeNum) * 100).toFixed(2) + "%";
          } else {
            v.ratio = "0%";
          }
        });
        this.listResult = repurchaseSkuList;
        this.list[0].val = coverNum;
        this.list[1].val = noticeNum;
        this.list[2].val = visitNum;
        this.list[3].val = payNum;
        this.list[4].val = payPrice;
        this.h[0].val = coverNum;
        this.h[1].val = noticeNum;
        this.h[2].val = visitNum;
        this.h[3].val = payNum;
        if (coverNum && noticeNum) {
          this.coverNumRatio = ((noticeNum / coverNum) * 100).toFixed(2) + "%";
        } else {
          this.coverNumRatio = "0%";
        }
        if (noticeNum && visitNum) {
          this.noticeNumVisRatio =
            ((visitNum / noticeNum) * 100).toFixed(2) + "%";
        } else {
          this.noticeNumVisRatio = "0%";
        }
        if (visitNum && payNum) {
          this.noticeNumRatio = ((payNum / visitNum) * 100).toFixed(2) + "%";
        } else {
          this.noticeNumRatio = "0%";
        }
        if (payNum && coverNum) {
          this.payNumRatio = ((payNum / coverNum) * 100).toFixed(2) + "%";
        } else {
          this.payNumRatio = "0%";
        }
      }
    },
    toPriceNum(num) {
      if (isNaN(num)) {
        num = 0;
      }
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    }
  }
};
</script>
<style lang='scss' scoped>
.msg-push-info {
  background: #fff;
  margin-bottom: 10px;
  padding: 20px;
  .img {
    width: 66px;
  }
}
.title {
  color: #222222;
  font-weight: bold;
  margin-bottom: 18px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.msg-info {
  > div {
    font-size: 14px;
    color: #222;
  }
}
.purchase-data {
  box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
  border-radius: 6px;
  .hm-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    text-align: center;
    line-height: 66px;
    background: #feeef5;
    .hmicon {
      font-size: 25px;
      color: #e50065;
    }
  }
  .purchase-name {
    color: #222222;
    font-size: 14px;
  }
  .purchase-val {
    font-size: 22px;
    font-weight: bold;
  }
}
.funnel {
  background-image: url("https://imgcdn.hemiao100.com/ThemePictures/%E6%BC%8F%E6%96%97%E5%9B%BE%402x444.png");
  height: 380px;
  background-size: 98% 100%;
  position: relative;
  background-repeat: no-repeat;
  .funnel-row {
    position: relative;
    line-height: 24px;
    .tit {
      position: absolute;
      right: 29%;
      color: #fff;
    }
  }
  .cover-notice {
    position: absolute;
    top: 16%;
    right: 5.5%;
    font-size: 14px;
  }
  .cover-access {
    position: absolute;
    top: 45%;
    right: 8%;
    font-size: 14px;
  }
  .notice-purchase {
    position: absolute;
    bottom: 19%;
    right: 10%;
    font-size: 14px;
  }
  .cover-purchase {
    position: absolute;
    bottom: 40%;
    font-size: 14px;
    right: 2%;
  }
}
</style>
